import { useTranslation } from 'react-i18next';

import { useTaxonomyContext } from '../../contexts/TaxonomyContext';

import { DataList } from './DataList';

export function TaxonomyList() {
  const { t } = useTranslation('translation', {
    keyPrefix: 'pages.Taxonomy.components.TaxonomyList',
  });
  const { taxonomyPropertiesUpdated } = useTaxonomyContext();
  const ifHasChange = !!taxonomyPropertiesUpdated?.data?.length;

  return (
    <section className="w-full max-w-[1280px]">
      {ifHasChange && (
        <div className="mb-4 rounded-md border border-yellow-200 bg-yellow-50 p-3 text-yellow-800">
          {t('hasUnsavedChanges')}
        </div>
      )}
      <header className="flex h-[54px] items-center bg-[#F4F4F4]">
        <div className="flex items-start gap-2 px-5 py-3">
          <strong className="w-[200px] text-sm font-bold">{t('group')}</strong>
          <strong className="w-[200px] text-sm font-bold">
            {t('property')}
          </strong>
          <strong className="text-sm font-bold">{t('examples')}</strong>
        </div>
      </header>
      <DataList />
    </section>
  );
}
